import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { useEffect } from "react";
import TextTranslate from "../../../utils/TextTranslate";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks";
import { updateViewState } from "../../../store/Slices/ViewManagerSlice";
import {
  playCallEndSound,
  stopOutgoingWaitSound,
} from "../../../utils/callSounds";

export default function CallDeclinedModal() {
  const dispatch = useAppDispatch();
  const ViewManager = useAppSelector((state) => state.ViewManager);
  const CallData = useAppSelector((state) => state.CallData);

  useEffect(() => {
    if (!ViewManager.show_call_declined_modal) return;
    stopOutgoingWaitSound();
    playCallEndSound();
  }, [ViewManager.show_call_declined_modal]);

  return (
    <>
      <Dialog
        open={ViewManager.show_call_declined_modal}
        as="div"
        className="relative z-[100]"
        onClose={() => {}}
      >
        <div className="fixed inset-0 z-[100] backdrop-blur-sm">
          <div className="flex min-h-full items-center justify-center p-4">
            <DialogPanel
              transition
              className="data-[closed]:transform-[scale(95%)] w-full max-w-lg rounded-2xl bg-modalBg p-6 text-center shadow-[rgba(17,_17,_26,_0.3)_0px_0px_16px] backdrop-blur-md transition-all duration-300 ease-in-out data-[closed]:opacity-0"
            >
              <img
                className="mx-auto my-4 h-14 w-14 rounded-lg object-cover"
                src={
                  CallData?.user?.profile_pic
                    ? CallData.user.profile_pic
                    : "/CallIcons/accept_call.png"
                }
                alt=""
              />
              <DialogTitle as="h3" className="text-xl font-medium">
                <TextTranslate text={`Call is Declined`} />
              </DialogTitle>
              <div className="mt-10 flex gap-3">
                <button
                  onClick={() => {
                    dispatch(
                      updateViewState({ show_call_declined_modal: false }),
                    );
                  }}
                  className={`relative mx-auto h-10 w-60 overflow-hidden rounded-lg bg-[#EA5F5F] px-4 py-2 text-base font-medium text-black outline-none lg:px-9 lg:text-lg`}
                >
                  <span className="">Go Back</span>
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
}
